export const californiaCities = [
  // Major Metropolitan Areas
  { name: 'Los Angeles', county: 'Los Angeles County', population: 3898747 },
  { name: 'San Diego', county: 'San Diego County', population: 1386932 },
  { name: 'San Jose', county: 'Santa Clara County', population: 1013240 },
  { name: 'San Francisco', county: 'San Francisco County', population: 873965 },
  { name: 'Fresno', county: 'Fresno County', population: 542107 },
  { name: 'Sacramento', county: 'Sacramento County', population: 524943 },
  { name: 'Long Beach', county: 'Los Angeles County', population: 466742 },
  { name: 'Oakland', county: 'Alameda County', population: 440646 },
  { name: 'Bakersfield', county: 'Kern County', population: 383579 },
  { name: 'Anaheim', county: 'Orange County', population: 346824 },
  { name: 'Santa Ana', county: 'Orange County', population: 334136 },
  { name: 'Riverside', county: 'Riverside County', population: 314998 },
  { name: 'Stockton', county: 'San Joaquin County', population: 310496 },
  { name: 'Irvine', county: 'Orange County', population: 307670 },
  { name: 'Chula Vista', county: 'San Diego County', population: 275487 },
  { name: 'Fremont', county: 'Alameda County', population: 230504 },
  { name: 'San Bernardino', county: 'San Bernardino County', population: 222101 },
  { name: 'Modesto', county: 'Stanislaus County', population: 218464 },
  { name: 'Fontana', county: 'San Bernardino County', population: 208393 },
  { name: 'Oxnard', county: 'Ventura County', population: 202063 },
  { name: 'Moreno Valley', county: 'Riverside County', population: 208634 },
  { name: 'Huntington Beach', county: 'Orange County', population: 198711 },
  { name: 'Glendale', county: 'Los Angeles County', population: 196543 },
  { name: 'Santa Clarita', county: 'Los Angeles County', population: 195058 },
  { name: 'Garden Grove', county: 'Orange County', population: 171949 },
  { name: 'Oceanside', county: 'San Diego County', population: 174648 },
  { name: 'Rancho Cucamonga', county: 'San Bernardino County', population: 174453 },
  { name: 'Santa Rosa', county: 'Sonoma County', population: 178127 },
  { name: 'Ontario', county: 'San Bernardino County', population: 175265 },
  { name: 'Lancaster', county: 'Los Angeles County', population: 173516 },
  { name: 'Elk Grove', county: 'Sacramento County', population: 176124 },
  { name: 'Corona', county: 'Riverside County', population: 157136 },
  { name: 'Palmdale', county: 'Los Angeles County', population: 169450 },
  { name: 'Salinas', county: 'Monterey County', population: 163542 },
  { name: 'Pomona', county: 'Los Angeles County', population: 151713 },
  { name: 'Hayward', county: 'Alameda County', population: 162954 },
  { name: 'Escondido', county: 'San Diego County', population: 151038 },
  { name: 'Torrance', county: 'Los Angeles County', population: 147067 },
  { name: 'Sunnyvale', county: 'Santa Clara County', population: 155805 },
  { name: 'Orange', county: 'Orange County', population: 139911 },
  { name: 'Fullerton', county: 'Orange County', population: 143617 },
  { name: 'Pasadena', county: 'Los Angeles County', population: 138699 },
  { name: 'Thousand Oaks', county: 'Ventura County', population: 126966 },
  { name: 'Visalia', county: 'Tulare County', population: 141384 },
  { name: 'Simi Valley', county: 'Ventura County', population: 126181 },
  { name: 'Concord', county: 'Contra Costa County', population: 129295 },
  { name: 'Roseville', county: 'Placer County', population: 147773 },
  { name: 'Victorville', county: 'San Bernardino County', population: 134810 },
  { name: 'Santa Clara', county: 'Santa Clara County', population: 127134 },
  { name: 'Vallejo', county: 'Solano County', population: 126090 }
];

export const lifeInsuranceKeywords = [
  'Life Insurance',
  'Term Life Insurance', 
  'Whole Life Insurance',
  'Life Insurance Quotes',
  'Life Insurance Online',
  'Cheap Life Insurance',
  'Life Insurance Rates',
  'Life Insurance Companies',
  'Life Insurance Agent',
  'No Exam Life Insurance',
  'Instant Life Insurance',
  'Affordable Life Insurance'
];

export const generateCityKeywordCombinations = () => {
  const combinations = [];
  
  californiaCities.forEach(city => {
    lifeInsuranceKeywords.forEach(keyword => {
      combinations.push({
        city: city.name,
        county: city.county,
        keyword,
        slug: `${city.name.toLowerCase().replace(/\s+/g, '-')}-${keyword.toLowerCase().replace(/\s+/g, '-')}`,
        title: `${keyword} in ${city.name}, California`,
        metaDescription: `Get ${keyword.toLowerCase()} in ${city.name}, CA. Licensed California insurance agents. No medical exam required. Get your quote online in minutes.`,
        h1: `${keyword} in ${city.name}, California`,
        localizedContent: {
          intro: `Residents of ${city.name}, California deserve reliable and affordable life insurance protection. Our licensed California insurance professionals serve ${city.county} and surrounding areas with comprehensive life insurance solutions.`,
          serviceArea: `Proudly serving ${city.name}, ${city.county}, and all of California`,
          localBenefits: [
            `Licensed in California (CA License #6013543)`,
            `Serving ${city.name} and ${city.county}`,
            `No medical exam required for most applicants`,
            `Online quotes available 24/7`,
            `Local California insurance expertise`
          ]
        }
      });
    });
  });
  
  return combinations;
};